import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AulaProgressoResponse } from "app/shared/models/ei-models/aula/response/aula-progresso.response";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AulaProgressService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/AulaProgresso/');

  constructor(private http: HttpClient) { super(); }

  get(aulaId: number) {
    return this.http.get<{
      aulaId: number; usuarioId: number; progressoPercentual: number;
      ultimaPosicaoSegundos: number; concluida: boolean;
    }>(
      this.controllerEndpoint.concat('Obter/', aulaId.toString()),
      { headers: this.getHeader(false) }
    );
  }

  getMany(aulaIds: number[]) {
    const params = new HttpParams().set('aulaIds', aulaIds.join(','));
    return this.http.get<Array<{
      aulaId: number; usuarioId: number; progressoPercentual: number;
      ultimaPosicaoSegundos: number; concluida: boolean;
    }>>(
      this.controllerEndpoint.concat('ObterPorAulas'),
      { headers: this.getHeader(false), params }
    );
  }

  getResumoUsuario() {
  return this.http.get<{
    usuarioId: number;
    segundosAssistidos: number;
    aulasAssistidas: number;
    aulasConcluidas: number;
  }>(
    this.controllerEndpoint.concat('ResumoUsuario'),
    { headers: this.getHeader(false) }
  );
}

  /**
   * Atualiza ou cria o progresso de uma aula
   * Retorna dados de gamificação se houver conquistas
   */
  upsert(aulaId: number, positionSec: number, markComplete = false): Observable<AulaProgressoResponse> {
    return this.http.put<AulaProgressoResponse>(
      this.controllerEndpoint.concat('Upsert/', aulaId.toString()),
      { positionSec, markComplete },
      { headers: this.getHeader(false) }
    );
  }
}